import React from 'react';
import { Outlet } from 'react-router-dom';
import { AdSignupProvider } from '@/contexts/AdSignupContext';

/**
 * Shared layout for the ad funnel routes (/ad and /ad/step).
 * Provides the in-memory AdSignupContext so the password never
 * touches sessionStorage.
 */
const AdLayout: React.FC = () => (
  <AdSignupProvider>
    <Outlet />
  </AdSignupProvider>
);

export default AdLayout;
